import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { ScrollableFiltersContext } from './hooks/hooks';
import styles from './ScommesseFiltersListScrollable.module.scss';
import { ViewAllButton } from './components';
import { SportsToolTipInfoScommessa } from 'types/swagger';
import { handleInfoScommesseModal } from 'features/modal/modalSlice';
import { Icon, IconsEnum } from 'components/Icons';
import { useAppDispatch } from 'lib/centralStore';
import { useTranslation } from 'hooks/useLingUI';

type ScommesseFiltersListScrollableTypeBaseProps = {
  color?: 'primary' | 'white';
  list: Array<ScommessaButton>;
  onSelectedElement: (_index: number) => void;
  className?: string;
  selectedItem: number;
};

export type ScommessaButton = {
  label: string;
  labelTrKey: string;
  scommesseDescription?: Array<SportsToolTipInfoScommessa>;
};
export type ScommesseFiltersListScrollableTypeExtendProps = ScommesseFiltersListScrollableTypeBaseProps & {
  subHeaderModalLabel?: string;
  headerModalLabel: string;
  limit: number;
};

export function ScommesseFiltersListScrollable(_props: ScommesseFiltersListScrollableTypeBaseProps): JSX.Element;
export function ScommesseFiltersListScrollable(_props: ScommesseFiltersListScrollableTypeExtendProps): JSX.Element;
export function ScommesseFiltersListScrollable(props: ScommesseFiltersListScrollableTypeExtendProps) {
  const { headerModalLabel, list, onSelectedElement, className, color, limit, subHeaderModalLabel } = props;
  const [selectedButton, setSelectedButton] = useState(props.selectedItem ?? 0);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const colorStyle = color === 'primary' ? styles.primary : styles.white;

  const handleSelectedElement = useCallback(
    (index: number) => {
      setSelectedButton(index);
      onSelectedElement(index);
    },
    [onSelectedElement]
  );

  let listToRender = list ? [...list] : [];

  const isViewAllVisible = limit && limit > 0 && list.length > limit;
  if (isViewAllVisible) {
    listToRender = listToRender.slice(0, limit);
  }

  return (
    <ScrollableFiltersContext.Provider value={{ state: selectedButton, setState: handleSelectedElement }}>
      <div className={classNames(className, styles.listContainer)}>
        {listToRender.map((item, index) => {
          return (
            <div
              className={item.scommesseDescription ? styles.buttonWrapperWithInfo : styles.buttonWrapper}
              key={item.label + '_' + index}
            >
              <button
                suppressHydrationWarning
                key={index}
                className={classNames(styles.button, [
                  {
                    [colorStyle]: selectedButton === index,
                    [styles.inactive]: selectedButton !== index,
                    [styles.radiusLeftBorder]: item.scommesseDescription,
                  },
                ])}
                onClick={() => {
                  handleSelectedElement(index);
                }}
              >
                {t(item.labelTrKey, item.label)}
              </button>

              {item.scommesseDescription && (
                <button
                  type="button"
                  className={classNames(styles.buttonInfo, [
                    {
                      [colorStyle]: selectedButton === index,
                      [styles.inactive]: selectedButton !== index,
                    },
                  ])}
                  onClick={(e) => {
                    console.log('click');
                    e.stopPropagation();
                    dispatch(
                      handleInfoScommesseModal({
                        isOpen: true,
                        title: t(item.labelTrKey, item.label),
                        description: item.scommesseDescription,
                      })
                    );
                  }}
                >
                  <Icon iconId={IconsEnum.INFO} className={styles.icon} color="var(--color-on-bg-secondary)" />
                </button>
              )}
            </div>
          );
        })}
        {isViewAllVisible && (
          <ViewAllButton
            list={list}
            key="view-all-button"
            headerModalLabel={headerModalLabel}
            subHeaderModalLabel={subHeaderModalLabel}
          />
        )}
      </div>
    </ScrollableFiltersContext.Provider>
  );
}
